import { useCallback } from "react";
import { useTranslation } from "react-i18next";

export const usePrice = () => {
  const { i18n } = useTranslation();

  const formatPrice = useCallback(
    (amount: string | number) =>
      new Intl.NumberFormat(i18n.resolvedLanguage, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(typeof amount === "string" ? parseFloat(amount) : amount),
    [i18n.resolvedLanguage]
  );

  return { formatPrice };
};
